import { ChatBotUIDateSlot } from "@jugl-web/domain-resources/chat-bot/types";
import { cx } from "@jugl-web/utils";
import isSameDay from "date-fns/isSameDay";
import { CSSProperties, FC, useMemo, useState } from "react";
import { DaySlotPicker } from "./DaySlotPicker";
import { TimeSlotPicker } from "./TimeSlotPicker";
import { BookingAttemptedMessage } from "./BookingAttemptedMessage";
import { QuickReplyButton } from "../QuickRepliesList";

interface ChatBotDateSlotBookingProps {
  slots: ChatBotUIDateSlot[];
  className?: string;
  style?: CSSProperties;
}

export const ChatBotDateSlotBooking: FC<ChatBotDateSlotBookingProps> = ({
  slots,
  className,
  style,
}) => {
  const [selectedDay, setSelectedDay] = useState<Date | null>(null);

  const [selectedSlot, setSelectedSlot] = useState<ChatBotUIDateSlot | null>(
    null
  );

  const slotsForSelectedDay = useMemo<ChatBotUIDateSlot[]>(() => {
    if (!selectedDay) {
      return [];
    }

    return slots
      .filter((slot) => isSameDay(slot.startTime, selectedDay))
      .sort((a, b) => a.startTime.getTime() - b.startTime.getTime());
  }, [slots, selectedDay]);

  const handleSlotSelect = (slot: ChatBotUIDateSlot) => {
    setSelectedSlot(slot);
    window.open(slot.id, "_blank");
  };

  const reset = () => {
    setSelectedDay(null);
    setSelectedSlot(null);
  };

  const content = useMemo(() => {
    if (selectedSlot) {
      return <BookingAttemptedMessage selectedSlot={selectedSlot} />;
    }

    if (selectedDay) {
      return (
        <TimeSlotPicker
          day={selectedDay}
          slots={slotsForSelectedDay}
          onSelect={handleSlotSelect}
          onGoBack={() => setSelectedDay(null)}
        />
      );
    }

    return <DaySlotPicker slots={slots} onSelect={setSelectedDay} />;
  }, [selectedDay, selectedSlot, slots, slotsForSelectedDay]);

  return (
    <div className={cx("w-full", className)} style={style}>
      <div className="border-dark-200 rounded-2xl border border-solid bg-white p-6">
        {content}
      </div>
      {selectedSlot && (
        <QuickReplyButton
          className="bg-grey-100 text mt-2 rounded-[20px]"
          onClick={reset}
        >
          Book another slot
        </QuickReplyButton>
      )}
    </div>
  );
};
